var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrvl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedTrvl0)",
    d: "M18.857 12c0 .429-.214 2.152-2.576 2.152c-1.676 0-2.983-1.029-3.707-1.616a.035.035 0 0 0-.043 0a.034.034 0 0 0-.008.047c.591.729 1.62 2.019 1.62 3.703c0 1.221-1.629 2.571-2.143 2.571V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedTrvl1)",
    d: "M7.714 9.857c1.676 0 2.979 1.025 3.707 1.616a.04.04 0 0 0 .026.012a.04.04 0 0 0 .026-.012a.034.034 0 0 0 0-.047c-.592-.729-1.62-2.031-1.62-3.712c0-2.57 1.932-2.57 2.147-2.57V12H5.143c0-.214 0-2.143 2.571-2.143"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedTrvl0",
    x1: 17.485,
    x2: 5.151,
    y1: 5.503,
    y2: 17.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA3A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedTrvl1",
    x1: 12.004,
    x2: 7.033,
    y1: 5.143,
    y2: 12.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A6966"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvl);
export default __webpack_public_path__ + "static/media/trvl.eb0bd662cb6582baa30a9cb507fb8853.svg";
export { ForwardRef as ReactComponent };